import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import LoadingView from '../loading/LoadingView';
import Button from '@mui/material/Button';
import { updateTask } from '../../api/operations';
import { setAlert } from '../../helpers/alerts';

const name_for_task = (task) => {
  switch (task.task_id) {
    case 'gha_workflow.run_workflow':
      return 'Trigger workflow';
    case 'gha_workflow.wait_until_completion':
      return 'Wait for workflow';
    case 'argocd.run_job':
      switch (task.parameters.job_name) {
        case 'collate-reindex':
          return 'Reindex';
        case 'collate-deploy-pipelines':
          return 'Deploy Pipelines';
        default:
          break;
      }
      return 'ArgoCD job';
      case 'argocd.update_version':
        return 'Update app version';
    default:
      return task.task_id;
    }
}

export default function SimpleTasksList(props) {
    const { tasks, loaded, error, reloadData } = props;
    const [rows, setRows] = React.useState([]);
    const navigate = useNavigate();
    
    const actionsFor = (r) => {
        switch (r.status) {
            case 'pending':
                return (
                    <div>
                    <Button variant="outlined" color="secondary" onClick={() => handleAction(r.uuid, "cancel")}>Cancel</Button>
                    </div>
                );
            case 'cancelled':
                return (
                    <div>
                    <Button variant="outlined" color="secondary" onClick={() => handleAction(r.uuid, "delete")}>Delete</Button>
                    </div>
                );
            case 'completed':
            case 'running':
            case 'errored':
                return (
                    <div>
                    <Button variant="outlined" color="primary" onClick={() => handleAction(r.uuid, "rerun")}>Rerun</Button>
                    </div>
                );
            default:
                return (<div></div>);
        }
    }
    const handleAction = (uuid, action) => {
      updateTask(uuid, action).then((r) => {
            if (reloadData) {
                reloadData();
            }
            if (setAlert) {
                setAlert(action, `${action} task "${r.task_id}"`, 'success');
            }
        }
        ).catch((e) => {
            setAlert(action, e, 'danger');
        });
    };

    React.useEffect(() => {
        if (loaded) {
            setRows(tasks);
        }
    }, [tasks, loaded, error]);

    
    if (!loaded) {
        return <LoadingView title="Loading tasks" />
    }
    if (error) {
        return <div>Error loading tasks: {error}</div>
    }
    if (rows.length === 0) {
      return <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 100}}>No tasks running</div>
    }
  return (
    <TableContainer>
      <Table  size="small" aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Task</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.uuid}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              onClick={()=>navigate(`/task/${row.uuid}`)}
            >
              <TableCell component="th" scope="row">
                {name_for_task(row)}
              </TableCell>
              <TableCell>{row.status}</TableCell>
              <TableCell>{actionsFor(row)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
